export default __webpack_public_path__ + "static/media/me2.fa61b895.png";